import { render } from "./autoComplete.vue?vue&type=template&id=656d63e6"
import script from "./autoComplete.vue?vue&type=script&lang=js"
export * from "./autoComplete.vue?vue&type=script&lang=js"
script.render = render

export default script